import React, { useState, useEffect } from 'react';
import api from '../services/api';
import TemplateForm from '../components/TemplateForm';
import Modal from '../components/Modal';
import { MessageTemplate } from '../types/Message';

// Icons
const PlusIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="12" y1="5" x2="12" y2="19"></line>
    <line x1="5" y1="12" x2="19" y2="12"></line>
  </svg>
);

const SearchIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="11" cy="11" r="8"></circle>
    <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
  </svg>
);

const EditIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
  </svg>
);

const TrashIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="3 6 5 6 21 6"></polyline>
    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
    <line x1="10" y1="11" x2="10" y2="17"></line>
    <line x1="14" y1="11" x2="14" y2="17"></line>
  </svg>
);

const MessageIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
  </svg>
);

const WhatsAppIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
  </svg>
);

const InstagramIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
    <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
    <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
  </svg>
);

const EmailIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
    <polyline points="22,6 12,13 2,6"></polyline>
  </svg>
);

const SmsIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
  </svg>
);

const MoreIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="1"></circle>
    <circle cx="19" cy="12" r="1"></circle>
    <circle cx="5" cy="12" r="1"></circle>
  </svg>
);

const Templates = () => {
  const [templates, setTemplates] = useState<MessageTemplate[]>([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [filterChannel, setFilterChannel] = useState<string>('all');
  const [showForm, setShowForm] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState<MessageTemplate | null>(null);
  const [menuOpen, setMenuOpen] = useState<number | null>(null);

  useEffect(() => {
    loadTemplates();
  }, []);

  const loadTemplates = async () => {
    try {
      setLoading(true);
      const response = await api.get('/messaging/templates/');
      const data = response.data.results || response.data;
      setTemplates(data);
    } catch (error) {
      console.error('Error loading templates:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSaveTemplate = async (data: Partial<MessageTemplate>) => {
    if (selectedTemplate) {
      await api.put(`/messaging/templates/${selectedTemplate.id}/`, data);
    } else {
      await api.post('/messaging/templates/', data);
    }
    setShowForm(false);
    setSelectedTemplate(null);
    loadTemplates();
  };

  const handleEdit = (template: MessageTemplate) => {
    setSelectedTemplate(template);
    setShowForm(true);
    setMenuOpen(null);
  };

  const handleDelete = async (template: MessageTemplate) => {
    if (window.confirm('Tem certeza que deseja excluir este template?')) {
      await api.delete(`/messaging/templates/${template.id}/`);
      setMenuOpen(null);
      loadTemplates();
    }
  };

  const handleAddNew = () => {
    setSelectedTemplate(null);
    setShowForm(true);
  };

  const getChannelIcon = (channel: string) => {
    switch (channel) {
      case 'whatsapp':
        return <WhatsAppIcon />;
      case 'instagram':
        return <InstagramIcon />;
      case 'email':
        return <EmailIcon />;
      case 'sms':
        return <SmsIcon />;
      default:
        return <MessageIcon />;
    }
  };

  const getChannelColor = (channel: string) => {
    switch (channel) {
      case 'whatsapp':
        return '#25D366';
      case 'instagram':
        return '#E1306C';
      case 'email':
        return '#EA4335';
      case 'sms':
        return '#4285F4';
      case 'messenger':
        return '#0084FF';
      default:
        return '#757575';
    }
  };

  const filteredTemplates = templates.filter(template => {
    const matchesSearch =
      template.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      template.body.toLowerCase().includes(searchTerm.toLowerCase()) ||
      template.category?.toLowerCase().includes(searchTerm.toLowerCase());

    const matchesChannel = filterChannel === 'all' || template.channel === filterChannel;

    return matchesSearch && matchesChannel;
  });

  const channelCounts = {
    all: templates.length,
    whatsapp: templates.filter(t => t.channel === 'whatsapp').length,
    instagram: templates.filter(t => t.channel === 'instagram').length,
    email: templates.filter(t => t.channel === 'email').length,
    sms: templates.filter(t => t.channel === 'sms').length,
  };

  return (
    <div style={{ padding: 'var(--space-6)', maxWidth: '1600px', margin: '0 auto' }}>
      {/* Header */}
      <div style={{ marginBottom: 'var(--space-6)' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 'var(--space-4)' }}>
          <div>
            <h1 style={{
              fontSize: 'var(--text-3xl)',
              fontWeight: 'var(--font-weight-bold)',
              color: 'var(--text-primary)',
              marginBottom: 'var(--space-2)'
            }}>
              Templates de Mensagem
            </h1>
            <p style={{ fontSize: 'var(--text-base)', color: 'var(--text-secondary)' }}>
              Gerencie seus modelos de mensagens para diferentes canais
            </p>
          </div>
          <button
            onClick={handleAddNew}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 'var(--space-2)',
              padding: 'var(--space-3) var(--space-5)',
              background: 'var(--gradient-primary)',
              border: 'none',
              borderRadius: 'var(--radius-lg)',
              color: 'white',
              fontSize: 'var(--text-sm)',
              fontWeight: 'var(--font-weight-semibold)',
              cursor: 'pointer',
              boxShadow: 'var(--shadow-md)',
              transition: 'all var(--transition-fast)'
            }}
          >
            <PlusIcon />
            Novo Template
          </button>
        </div>

        {/* Search and Filter */}
        <div style={{
          display: 'flex',
          gap: 'var(--space-4)',
          alignItems: 'center',
          flexWrap: 'wrap'
        }}>
          <div style={{
            flex: 1,
            minWidth: '280px',
            position: 'relative'
          }}>
            <div style={{
              position: 'absolute',
              left: 'var(--space-4)',
              top: '50%',
              transform: 'translateY(-50%)',
              color: 'var(--text-tertiary)'
            }}>
              <SearchIcon />
            </div>
            <input
              type="text"
              placeholder="Buscar templates..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={{
                width: '100%',
                padding: 'var(--space-3) var(--space-4) var(--space-3) var(--space-11)',
                background: 'var(--glass-bg)',
                backdropFilter: 'var(--glass-blur)',
                border: '1px solid var(--glass-border)',
                borderRadius: 'var(--radius-lg)',
                fontSize: 'var(--text-sm)',
                color: 'var(--text-primary)',
                outline: 'none',
                transition: 'all var(--transition-fast)'
              }}
            />
          </div>

          <div style={{ display: 'flex', gap: 'var(--space-2)' }}>
            {[
              { value: 'all', label: 'Todos' },
              { value: 'whatsapp', label: 'WhatsApp' },
              { value: 'instagram', label: 'Instagram' },
              { value: 'email', label: 'Email' },
              { value: 'sms', label: 'SMS' }
            ].map((channel) => (
              <button
                key={channel.value}
                onClick={() => setFilterChannel(channel.value)}
                style={{
                  padding: 'var(--space-2) var(--space-4)',
                  background: filterChannel === channel.value
                    ? 'var(--gradient-primary)'
                    : 'var(--glass-bg)',
                  backdropFilter: 'var(--glass-blur)',
                  border: filterChannel === channel.value
                    ? 'none'
                    : '1px solid var(--glass-border)',
                  borderRadius: 'var(--radius-lg)',
                  color: filterChannel === channel.value ? 'white' : 'var(--text-secondary)',
                  fontSize: 'var(--text-sm)',
                  fontWeight: 'var(--font-weight-medium)',
                  cursor: 'pointer',
                  transition: 'all var(--transition-fast)',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 'var(--space-2)'
                }}
              >
                {channel.label}
                <span style={{
                  padding: '2px 6px',
                  background: filterChannel === channel.value ? 'rgba(255,255,255,0.2)' : 'var(--bg-tertiary)',
                  borderRadius: 'var(--radius-full)',
                  fontSize: 'var(--text-xs)'
                }}>
                  {channelCounts[channel.value as keyof typeof channelCounts]}
                </span>
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Templates Grid */}
      {loading ? (
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 'var(--space-16)',
          background: 'var(--glass-bg)',
          backdropFilter: 'var(--glass-blur)',
          borderRadius: 'var(--radius-2xl)',
          border: '1px solid var(--glass-border)'
        }}>
          <div style={{ textAlign: 'center' }}>
            <div style={{
              width: '48px',
              height: '48px',
              borderRadius: '50%',
              border: '3px solid var(--color-primary-200)',
              borderTopColor: 'var(--color-primary-600)',
              animation: 'spin 1s linear infinite',
              margin: '0 auto var(--space-4)'
            }} />
            <p style={{ color: 'var(--text-secondary)' }}>Carregando templates...</p>
          </div>
        </div>
      ) : filteredTemplates.length === 0 ? (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 'var(--space-16)',
          background: 'var(--glass-bg)',
          backdropFilter: 'var(--glass-blur)',
          borderRadius: 'var(--radius-2xl)',
          border: '1px solid var(--glass-border)'
        }}>
          <div style={{
            width: '80px',
            height: '80px',
            borderRadius: 'var(--radius-xl)',
            background: 'var(--bg-tertiary)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: 'var(--space-4)',
            color: 'var(--text-tertiary)'
          }}>
            <MessageIcon />
          </div>
          <h3 style={{ fontSize: 'var(--text-lg)', fontWeight: 'var(--font-weight-semibold)', color: 'var(--text-primary)', marginBottom: 'var(--space-2)' }}>
            Nenhum template encontrado
          </h3>
          <p style={{ fontSize: 'var(--text-sm)', color: 'var(--text-secondary)', marginBottom: 'var(--space-4)' }}>
            {searchTerm ? 'Tente outra busca' : 'Crie seu primeiro template'}
          </p>
          {!searchTerm && (
            <button
              onClick={handleAddNew}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 'var(--space-2)',
                padding: 'var(--space-3) var(--space-5)',
                background: 'var(--gradient-primary)',
                border: 'none',
                borderRadius: 'var(--radius-lg)',
                color: 'white',
                fontSize: 'var(--text-sm)',
                fontWeight: 'var(--font-weight-semibold)',
                cursor: 'pointer'
              }}
            >
              <PlusIcon />
              Criar Template
            </button>
          )}
        </div>
      ) : (
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(340px, 1fr))',
          gap: 'var(--space-4)'
        }}>
          {filteredTemplates.map((template) => (
            <div
              key={template.id}
              style={{
                background: 'var(--glass-bg-strong)',
                backdropFilter: 'var(--glass-blur)',
                borderRadius: 'var(--radius-xl)',
                border: '1px solid var(--glass-border)',
                borderLeft: `4px solid ${getChannelColor(template.channel)}`,
                padding: 'var(--space-5)',
                display: 'flex',
                flexDirection: 'column',
                transition: 'all var(--transition-fast)'
              }}
            >
              {/* Header */}
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 'var(--space-3)' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--space-3)' }}>
                  <div style={{
                    width: '40px',
                    height: '40px',
                    borderRadius: '50%',
                    background: getChannelColor(template.channel),
                    color: 'white',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}>
                    {getChannelIcon(template.channel)}
                  </div>
                  <div>
                    <h3 style={{ fontSize: 'var(--text-base)', fontWeight: 'var(--font-weight-semibold)', color: 'var(--text-primary)', marginBottom: '2px' }}>
                      {template.name}
                    </h3>
                    <span style={{ fontSize: 'var(--text-xs)', color: 'var(--text-tertiary)', textTransform: 'uppercase' }}>
                      {template.channel}
                    </span>
                  </div>
                </div>
                <div style={{ position: 'relative' }}>
                  <button
                    onClick={() => setMenuOpen(menuOpen === template.id ? null : template.id)}
                    style={{
                      padding: 'var(--space-2)',
                      background: 'transparent',
                      border: 'none',
                      borderRadius: 'var(--radius-md)',
                      cursor: 'pointer',
                      color: 'var(--text-tertiary)'
                    }}
                  >
                    <MoreIcon />
                  </button>
                  {menuOpen === template.id && (
                    <div style={{
                      position: 'absolute',
                      top: '100%',
                      right: 0,
                      background: 'var(--bg-primary)',
                      borderRadius: 'var(--radius-lg)',
                      boxShadow: 'var(--shadow-lg)',
                      border: '1px solid var(--border-light)',
                      minWidth: '140px',
                      zIndex: 10
                    }}>
                      <button
                        onClick={() => handleEdit(template)}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 'var(--space-2)',
                          width: '100%',
                          padding: 'var(--space-3) var(--space-4)',
                          background: 'transparent',
                          border: 'none',
                          cursor: 'pointer',
                          fontSize: 'var(--text-sm)',
                          color: 'var(--text-primary)',
                          textAlign: 'left'
                        }}
                      >
                        <EditIcon /> Editar
                      </button>
                      <button
                        onClick={() => handleDelete(template)}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 'var(--space-2)',
                          width: '100%',
                          padding: 'var(--space-3) var(--space-4)',
                          background: 'transparent',
                          border: 'none',
                          cursor: 'pointer',
                          fontSize: 'var(--text-sm)',
                          color: 'var(--color-error-500)',
                          textAlign: 'left'
                        }}
                      >
                        <TrashIcon /> Excluir
                      </button>
                    </div>
                  )}
                </div>
              </div>

              {/* Subject (email only) */}
              {template.subject && (
                <p style={{ fontSize: 'var(--text-sm)', color: 'var(--text-secondary)', marginBottom: 'var(--space-2)' }}>
                  <strong>Assunto:</strong> {template.subject}
                </p>
              )}

              {/* Body */}
              <div style={{ flex: 1, marginBottom: 'var(--space-3)' }}>
                <p style={{
                  fontSize: 'var(--text-sm)',
                  color: 'var(--text-secondary)',
                  display: '-webkit-box',
                  WebkitLineClamp: 3,
                  WebkitBoxOrient: 'vertical',
                  overflow: 'hidden',
                  lineHeight: '1.5'
                }}>
                  {template.body}
                </p>
              </div>

              {/* Tags */}
              {template.tags && template.tags.length > 0 && (
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 'var(--space-1)', marginBottom: 'var(--space-3)' }}>
                  {template.tags.map((tag, index) => (
                    <span
                      key={index}
                      style={{
                        padding: '2px 8px',
                        background: 'var(--bg-tertiary)',
                        borderRadius: 'var(--radius-full)',
                        fontSize: 'var(--text-xs)',
                        color: 'var(--text-secondary)'
                      }}
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              )}

              {/* Variables */}
              {template.variables && template.variables.length > 0 && (
                <div style={{ marginBottom: 'var(--space-3)' }}>
                  <span style={{ fontSize: 'var(--text-xs)', color: 'var(--text-tertiary)', display: 'block', marginBottom: 'var(--space-1)' }}>
                    Variáveis:
                  </span>
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: 'var(--space-1)' }}>
                    {template.variables.map((variable, index) => (
                      <span
                        key={index}
                        style={{
                          padding: '2px 8px',
                          background: 'rgba(99, 102, 241, 0.1)',
                          border: '1px solid rgba(99, 102, 241, 0.3)',
                          borderRadius: 'var(--radius-full)',
                          fontSize: 'var(--text-xs)',
                          color: 'var(--color-primary-600)'
                        }}
                      >
                        {variable}
                      </span>
                    ))}
                  </div>
                </div>
              )}

              {/* Footer */}
              <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                paddingTop: 'var(--space-3)',
                borderTop: '1px solid var(--border-light)'
              }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--space-2)' }}>
                  <span style={{ fontSize: 'var(--text-xs)', color: 'var(--text-tertiary)' }}>
                    {template.usage_count} uso{template.usage_count !== 1 ? 's' : ''}
                  </span>
                  {template.category && (
                    <span style={{
                      padding: '2px 8px',
                      background: 'var(--bg-tertiary)',
                      borderRadius: 'var(--radius-full)',
                      fontSize: 'var(--text-xs)',
                      color: 'var(--text-secondary)'
                    }}>
                      {template.category}
                    </span>
                  )}
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--space-2)' }}>
                  <span style={{
                    padding: '2px 8px',
                    background: template.is_active ? 'rgba(34, 197, 94, 0.1)' : 'var(--bg-tertiary)',
                    color: template.is_active ? 'var(--color-success-600)' : 'var(--text-tertiary)',
                    borderRadius: 'var(--radius-full)',
                    fontSize: 'var(--text-xs)',
                    fontWeight: 'var(--font-weight-medium)'
                  }}>
                    {template.is_active ? 'Ativo' : 'Inativo'}
                  </span>
                  <span style={{
                    padding: '2px 8px',
                    background: 'var(--bg-tertiary)',
                    borderRadius: 'var(--radius-full)',
                    fontSize: 'var(--text-xs)',
                    color: 'var(--text-secondary)'
                  }}>
                    {template.is_public ? 'Público' : 'Privado'}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Form Modal */}
      <Modal
        isOpen={showForm}
        onClose={() => {
          setShowForm(false);
          setSelectedTemplate(null);
        }}
        title={selectedTemplate ? 'Editar Template' : 'Novo Template'}
      >
        <TemplateForm
          template={selectedTemplate}
          onSave={handleSaveTemplate}
          onCancel={() => {
            setShowForm(false);
            setSelectedTemplate(null);
          }}
        />
      </Modal>

      <style>{`
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default Templates;
